module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外管工作台")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("合同到期提醒")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rule-bar"
  }, [_c('span', {
    staticClass: "rule-dot"
  }), _vm._v("\n    规则：合同到期前 "), _c('b', [_vm._v(_vm._s(_vm.rules.contractAlertDays))]), _vm._v(" 天触发续签提醒；到期日次日起进入"), _c('b', [_vm._v("超期")]), _vm._v("状态并按天累计，直至登记新合同。未登记合同的老师只在「全部」里显示。\n    "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/hrWorkbench/settings')
      }
    }
  }, [_vm._v("调整规则")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-bar"
  }, [_c('span', {
    staticClass: "toolbar-label"
  }, [_vm._v("外教运营")]), _vm._v(" "), _c('adviser-select', {
    on: {
      "on-change": _vm.onAdviserChange
    },
    model: {
      value: (_vm.adviserId),
      callback: function($$v) {
        _vm.adviserId = $$v
      },
      expression: "adviserId"
    }
  }), _vm._v(" "), _c('Button-group', {
    staticClass: "seg"
  }, _vm._l((_vm.levelTabs), function(item) {
    return _c('Button', {
      key: item.value,
      attrs: {
        "type": _vm.level === item.value ? 'primary' : 'ghost'
      },
      on: {
        "click": function($event) {
          return _vm.changeLevel(item.value)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.label) + " " + _vm._s(_vm.counts[item.value] || 0) + "\n      ")])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "toolbar-total"
  }, [_vm._v("共 " + _vm._s(_vm.dataList.length) + " 人")]), _vm._v(" "), _c('Button', {
    staticClass: "export-btn",
    on: {
      "click": _vm.exportCsv
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list-table"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.dataList,
      "loading": _vm.searchLoading,
      "stripe": "",
      "row-class-name": _vm.rowClassName,
      "no-data-text": "当前筛选下无记录"
    }
  })], 1), _vm._v(" "), _c('contract-renew-modal', {
    attrs: {
      "value": _vm.showRenew,
      "row": _vm.currentRow
    },
    on: {
      "on-close": function($event) {
        _vm.showRenew = false
      },
      "on-success": _vm.search
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2db93d1a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrWorkbench/HrWorkbenchContract.vue
// module id = 1710
// module chunks = 8